<template>
    <div class="container-table">
      <q-card-section>
        <q-table
          data-cy="ciudades-table"
          :data="dataCiudades"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :pagination.sync="pagination"
          :loading=" isLoadingDirect!= null ? isLoadingDirect : isLoading"
          :selected.sync="selected"
          binary-state-sort
        >
        <template v-slot:body-cell-estado="props"><q-td data-cy='estado' :props="props" key='estado'>{{props.selected?'Visible':''}}</q-td></template>
        <template v-slot:body-cell-name="props">
          <q-td data-cy='nameCity' key="name" :props="props">
                <q-btn class='imgBtn' round style='cursor:auto'>
                  <q-avatar size="42px">
                    <img :src="props.row.file.length===1 && props.row.file[0].fileKey==='imagen-logo'? props.row.file[0].url : props.row.file.length===2? props.row.file[1].url : require(`@/assets/${imgDefault}`)">
                  </q-avatar>
                </q-btn>
                {{ props.row.name }}
              </q-td>
          </template>
          <template v-slot:body-cell-fechaCreacion="props">
            <q-td key="fechaCreacion" :props="props">
                {{ props.row.fechaCreacion | shortDate }}
              </q-td>
          </template>
          <template v-slot:body-cell-editar="props">
            <q-td key="editar" :props="props">
                <q-icon
                  data-cy="bEditCity"
                  name="o_create"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerEdit(props.row)"
                />
              </q-td>
          </template>
          <template v-slot:body-cell-eliminar="props">
            <q-td key="eliminar" :props="props">
                <q-icon
                  data-cy="bDeleteCity"
                  name="o_delete"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerDelete(props.row)"
                />
              </q-td>
          </template>
          <template v-slot:body-selection="props">
            <q-checkbox
              data-cy="checkBox"
              color="primary"
              v-model="props.selected"
              @input='(v) => saveValue(v, props.row)'
            />
          </template>
          <template v-slot:header-selection="props">
            <q-checkbox color="primary" v-model="props.selected" @input='selectAll()' />
          </template>
        </q-table>
        </q-card-section>
        <DialogDelete
          v-if="rowSelectedtoDelete"
          v-model="showDialogDelete"
          dataCy="delete-ciudad"
          :showIcon="true"
          :txtContainer="`¿Está seguro de eliminar el municipio? ${rowSelectedtoDelete.name}`"
          @save="deleteCity()"
        />
    </div>
</template>
<script>

import {
  QCheckbox,
  QTable,
  QTd,
  QCardSection,
  QAvatar
} from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';

export default {
  components: {
    QCheckbox,
    QTable,
    QTd,
    QCardSection,
    QAvatar,
    DialogDelete
  },
  props: {
    isLoading: Boolean,
    imgDefault: {
      type: String,
      default: function () {
        return 'img/iconfinder-icon-image.png';
      }
    }
  },
  mixins: [Loading],
  data () {
    return {
      pagination: {
        rowsPerPage: 20
      },
      selected: [],
      isLoadingDirect: null,
      showDialogDelete: false,
      rowSelectedtoDelete: null,
      columns: [
        {
          name: 'estado',
          label: 'Estado',
          align: 'left',
          field: 'visible',
          sortable: true
        },
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true,
          sort: (a, b) => b.localeCompare(a)
        },
        {
          name: 'fechaCreacion',
          label: 'Fecha de Creación',
          align: 'left',
          field: 'fechaCreacion',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'center',
          field: '',
          sortable: false
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      dataCiudades: types.ALL_CIUDADES,
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  created () {
    if (this.dataCiudades !== null && this.dataCiudades !== undefined && Object.entries(this.dataCiudades).length > 0) {
      this.loadVisibleCiudades();
    }
  },
  methods: {
    loadVisibleCiudades () {
      this.selected = this.dataCiudades.filter(n => n.estado === true).map((n) => {
        if (n.estado === true) {
          return { id: n.id };
        }
      });
    },
    triggerEdit (row) {
      let id = row.id;
      this.$router.push({ name: 'form_edit_ciudades', params: { idCiudad: id } });
    },
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteCity () {
      // obtenemos indice
      const index = this.dataCiudades.indexOf(this.rowSelectedtoDelete);
      // copia del objeto del array
      var cities = Object.assign([], this.dataCiudades);
      // eliminamos el elemento
      cities.splice(index, 1);
      this.$store.dispatch(types.ACTION_DELETE_CIUDAD, { idCiudad: this.rowSelectedtoDelete.id, items: cities }).then(response => {
        this.showDialogDelete = false;
        this.hideLoading();
        this.isLoadingDirect = false;

        this.refreshAllCities();
        this.loadVisibleCiudades();
      }).catch(() => { this.hideLoading(); this.isLoadingDirect = false; });
    },
    refreshAllCities () {
      this.$store.dispatch(types.ACTION_GET_ALL_CIUDADES).then(resp => {
        this.hideLoading();
        if (this.ciudadSelected.id === this.rowSelectedtoDelete.id) {
          // cambiar la ciudad seleccionada por la primera del select de ciudades
          this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: resp.data[0].id }).then(response => {
            this.hideLoading();
            this.$store.commit('NGUD/setCiudadSelected', response.data);
          }).catch(() => { this.hideLoading(); });
        }
      }).catch(() => { this.hideLoading(); });
    },
    selectAll () {
      this.dataCiudades.forEach(city => {
        let estado = false;
        var filtered = this.selected.filter(e => e.id === city.id);
        if (filtered.length > 0) {
          estado = true;
        }
        this.saveValue(estado, city);
      });
    },
    async saveValue (value, row) {
      this.isLoadingDirect = true;
      this.perpareDataToSaveCiudad(row, value).then(ciudad => {
        this.saveCiudad(ciudad, row.id);
      });
    },
    async perpareDataToSaveCiudad (row, value) {
      let ciudad = null;
      let ciudadObject = null;
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: row.id }).then(response => {
        this.hideLoading();
        ciudad = response.data;

        ciudadObject = {
          Name: ciudad.name,
          Estado: value,
          File: null,
          Indices: ciudad.indices.length > 0 ? ciudad.indices : [],
          IndicesTematicos: ciudad.indicesTematicos.length > 0 ? ciudad.indicesTematicos : [],
          indicadoresContratados: ciudad.indicadoresContratados.length > 0 ? ciudad.indicadoresContratados : [],
          usuarioProveedor: ciudad.usuarioProveedor,
          idProveedor: ciudad.idProveedor,
          claveProveedor: ciudad.claveProveedor
        };
      }).catch(() => { this.hideLoading(); });
      return ciudadObject;
    },
    async saveCiudad (ciudad, id) {
      let modify = {
        'estado': ciudad.estado
      };
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_CIUDAD, { newCity: ciudad, idCiudad: id, objModify: modify }).then(response => {
        this.hideLoading();
        this.isLoadingDirect = false;
      }).catch(() => { this.hideLoading(); this.isLoadingDirect = false; });
    }
  }
};
</script>
<style lang="scss" scoped>
button.q-btn.imgBtn{
  margin-left: 0px !important;
  margin-right: 15px;
}
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
